import React from "react";
import {ChipLabel} from "./index";

const AddressSuggestionChip = ({show, valid, suggested, value}) => {
    const ignoredKeywords = ["city"];
    const ignoredRegExp = new RegExp(`${ignoredKeywords.join("|")}`, "g");

    const removeIgnorableKeywords = (text) => {
        if (text) {
            return text.toLowerCase().replace(ignoredRegExp, "").trim();
        } else {
            return "";
        }
    }

    const chipClass = () => {
        if (!valid) {
            return "warning";
        } else {
            return value && (removeIgnorableKeywords(suggested) === removeIgnorableKeywords(value)) ? "success" : "warning"
        }
    }

    return <>
        {
            show ? <ChipLabel
                label={valid ? suggested : "Unknown address"}
                className={`status-chip ${chipClass()}`}
            /> : null
        }
    </>
}

export default AddressSuggestionChip;